import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Index } from '@classes/index';
// import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UiService } from './ui.service';
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class IndexService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/index';

  public masterIndex = new BehaviorSubject<Index | null>(null);
  public currentIndex = new BehaviorSubject<Index | null>(null);
  public currentCoef = new BehaviorSubject<number | null>(null);

  constructor(
    private http: HttpClient,
    public uiService: UiService,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getIndexs(): Observable<Array<Index>> {
    return this.http.get<Array<Index>>(this.basePath);
  }

  getMasterIndex(): void {
    this.uiService.addRouteLoading();
    this.http.get<Index>(this.basePath + '/GetMasterIndex').subscribe(
      index => {
        this.masterIndex.next(index);
        if (this.currentIndex.value != null) {
          this.calculIndex();
        }
        this.uiService.removeRouteLoading();
      }, error => {
        console.error(error);
        this.uiService.removeRouteLoading();
      });
  }

  getCurrentIndex(): void {
    this.uiService.addRouteLoading();
    this.http.get<Index>(this.basePath + '/GetCurrentIndex').subscribe(
      index => {
        this.currentIndex.next(index);
        if (this.masterIndex.value != null) {
          this.calculIndex();
        }
        this.uiService.removeRouteLoading();
      }, error => {
        // this.uiService.displayMessageToast('errormessage.no-current-index');
        console.error(error);
        this.uiService.removeRouteLoading();
      });
  }

  private calculIndex() {
    const coef: number = (this.currentIndex?.value?.value || 1) / (this.masterIndex?.value?.value || 1);
    this.currentCoef.next(coef);
  }

  createOrUpdateIndex(index?: Index): Observable<Index> {
    if (index?.id) {
      //update
      const url = `${this.basePath}/${index?.id}`;
      return this.http.patch<any>(url,
        index).pipe(map(m => {
          return m
        }));
    } else {
      //create
      return this.http.post<any>(this.basePath,
        index
      ).pipe(map(m => {
        return m
      }));
    }
  }

}
